module.exports = __webpack_public_path__ + "static/instagram-mob-a5bef8a92eb8a4c2dff06d592088305d.jpg";